export const TITLE = "documentation_area.sign_up_form.company.title";
export const BUTTON_TEXT = "common.continue";
export const SECTION_COMPANY = "documentation_area.sign_up_form.section.company";
export const SECTION_LEGAL_REPRESENTATIVE =
  "documentation_area.sign_up_form.section.legal_representative";
export const COMPANY_NIF_TITLE = "documentation_area.sign_up_form.input.company_nif";
export const COMPANY_NIF_PLACEHOLDER =
  "documentation_area.sign_up_form.input.company_nif.placeholder";
export const COMPANY_NIF_ERROR = "documentation_area.sign_up_form.input.company_nif.error";
export const COMPANY_NAME_TITLE = "documentation_area.sign_up_form.input.company_name";
export const COMPANY_NAME_PLACEHOLDER =
  "documentation_area.sign_up_form.input.company_name.placeholder";
export const ID_NUMBER_INPUT_TITLE =
  "documentation_area.sign_up_form.input.representative_id_number";
export const ID_NUMBER_INPUT_PLACEHOLDER =
  "documentation_area.sign_up_form.input.id_number.placeholder";
export const ID_NUMBER_ERROR = "documentation_area.sign_up_form.input.id_number.error";
export const REPRESENTATIVE_ROLE_TITLE =
  "documentation_area.sign_up_form.input.representative_role";
export const REPRESENTATIVE_ROLE_PLACEHOLDER =
  "documentation_area.sign_up_form.input.representative_role.placeholder";
export const REPRESENTATIVE_INFO = "documentation_area.sign_up_form.info.representative_legal";
export const INVALID_INDIVIDUAL_RELATION_TYPE_ERROR =
  "documentation_area.sign_up_form.input.representative_role.invalid_individual_relation_type.error";

export const ERROR_MAP: Record<string, string> = {
  INVALID_INDIVIDUAL_RELATION_TYPE: INVALID_INDIVIDUAL_RELATION_TYPE_ERROR,
};
